export const addresses = {
  wallet: "0x0825F964e96c6ac72a14cD74B70f3682B48fC40e",
  alphabetProvider: "0x5Cad7e6dFdC0a4Fbd6664aEA2CC100Bb8c915D77",
};
